import styled from "styled-components";

const VerificationFormStyles = styled.div`
  form {
    background: transparent;
    border-radius: 8px;
    font-family: inherit;
    scroll-margin-top: 140px;
    // padding: 16px 16px;
    // margin: 0 16px 40px 16px;
    // box-shadow: 1px 1px 10px rgba(000,000,000, .3);
    position: relative;
    color: #000;
  }
  .cvf__step {
    margin: 0 0 40px 0;
    padding: 0;
  }
  .cvf__response--container {
    padding: 0;
    margin: 0;
  }
  .cvf__response {
    font-size: 16px;
    padding: 0 0 12px 0;
    margin: 0;
  }
  .cvf__copy {
    font-size: 16px;
    margin-bottom: 24px;
    line-height: 28px;
  }
  .cvf__step--header {
    display: flex;
    grid-gap: 18px;
  }
  .cvf__step img {
    margin: 0 auto;
    text-align: center;
    display: block;
  }
  .cvf__title {
    font-weight: bold;
    margin-bottom: 12px;
    font-family: inherit;
    font-size: 18px;
  }
  .cvf__input-container {
    margin-bottom: 18px;
  }
  .cvf__svg {
    text-align: center;
    margin: 0 auto;
  }
  .cvf__button_container {
    display: flex;
    grid-gap: 16px;
    margin: 24px auto;
    justify-content: flex-end;
    align-items: center;
  }
  .cvf__navigation-link {
    color: ${(props) =>
      props.$primary_color ? props.$primary_color : "#e0e0e0"};
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
  }
  .cvf__lower-content {
    opacity: 0;
    transition: opacity 0.8s ease;
  }
  .cvf__lower-content.show {
    opacity: 1;
  }
  .cvf__lower-content.submitting {
    opacity: 0.2;
    pointer-events: none;
  }
  .cvf__response-screen {
    margin: 0 0 40px 0;
    padding: 24px;
    text-align: left;
  }
  .cvf__response-screen--title {
    margin: 0 0 12px 0;
    font-weight: bold;
    text-align: left;
    padding: 0 0 8px 0;
  }
  .cvf__response-screen--copy {
    margin: 0 0 12px 0;
    text-align: left;
    font-size: 16px;
  }
  .cvf__response-screen--copy.success-msg {
    background: #e8f8ea;
    border: 1px solid #22bb33;
    padding: 16px;
    line-height: 28px;
    border-radius: 8px;
  }
  .cvf__response-screen--copy.small {
    font-size: 16px;
  }
  .cvf__response-screen--copy a {
    color: ${(props) =>
      props.$primary_color ? props.$primary_color : "#e0e0e0"};
  }
  .cvf__loading-icon {
    position: absolute;
    width: 100px;
    top: 0;
    bottom: 0;
  }
  .cvf__disclaimer {
    font-size: 11px;
    font-style: italic;
    border-top: 1px solid #eee;
    padding-top: 8px;
  }
  .cvf__disclaimer strong {
    font-weight: bold;
  }
  .checkbox-input__container label {
    font-size: 11px !important;
    font-weight: normal;
  }
  .cvf__spinner-container {
    width: 100px;
    max-height: 200px;
    margin: 0 auto;
  }
`;

export default VerificationFormStyles;
